import { vuwer } from "@@assets/scripts/common";

vuwer.add("customSection", {
	selector: "#custom_section"
}, function() {
	this.add("slider", {
		vuwType: "slider",
		
		selector() {
			return this.container.$self && this.container.$self.children(
				".slider"
			);
		},
		
		slickOptions: {
			fade: true,
			dots: false,
			infinite: true
		}
	});
});
